import { B2bAddBox } from 'src/components/biz-b2b-add-box';

export default B2bAddBox;
